import React, { Component, } from 'react';
import styled from 'styled-components';
import { connect, } from 'react-redux';
import { object, func, string, element, oneOfType, } from 'prop-types';
import { NavLink, withRouter, } from 'react-router-dom';
import { color, } from '../../../legacy-tv-dls';

import { unAuthUser, resetErrMsg, } from '../../../actions';
import fetchAdjustment from '../../../scenes/Adjustment/actions/fetchPageApi';
import { USERS_MAP, } from '../../../constant';

const PropTypes = {
  match: object.isRequired,
  resetErrMsg: func.isRequired,
  unAuthUser: func.isRequired,
  adjustment: object.isRequired,
  token: string.isRequired,
  company: string.isRequired,
  fetchAdjustment: func.isRequired,
};
const DefaultProps = {};

const SectionTitle = styled.h4`
  padding: 8px 15px;
  background-color: #f5f5f5;
  font-weight: normal;
  font-size: 14px;
  color: #aaa;
  margin: 0 0 40px;
  position: relative;
`;

const SideNavContainer = styled.ul`
  background-color: #fff;
  min-height: calc(100vh - 50px);
  box-shadow: 1px 1px 10px rgba(0,0,0,.22);
  width: 240px;
  z-index: 1;
`;

const NavItem = styled.li`
  display: flex;
  align-items: center;
  padding: 15px;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
`;
const Icon = styled.i`
  width: 24px;
  margin: 0 20px 0 12px;
  && {
    font-size: 24px;
  }
`;
const DateBadge = styled.span`
  padding-right: 5px;
  color: ${color.brand.primary['500']};
`;

const NavItemContainer = ({ icon, children, ...rest }) => {
  return (
    <NavItem {...rest}>
      {
        icon && <Icon className={`fa ${icon}`} />
      }
      {children}
    </NavItem>
  );
};
NavItemContainer.propTypes = { icon: string, children: oneOfType([element, string]), };
NavItemContainer.defaultProps = { icon: null, children: null, };

const styles = {
  navLink: {
    display: 'inline-block',
    width: '100%',
    textDecoration: 'none',
    color: '#888',
  },
};

export class SideNav extends Component {
  static propTypes = PropTypes
  static defaultProps = DefaultProps
  componentWillMount() {
    const {
      match,
      token,
      company,
    } = this.props;
    const { year, month, } = match.params;
    this.props.fetchAdjustment(company, year, month, token);
  }
  render() {
    const {
      match,
      unAuthUser,
      resetErrMsg,
      adjustment,
    } = this.props;
    const { projectId, year, month, } = match.params;
    const hasAdjustment = adjustment[year] && adjustment[year][month];
    return (
      <SideNavContainer>
        <NavLink
          to={`/${projectId}/date-select`}
          style={styles.navLink}
          onClick={resetErrMsg}
        >
          <NavItemContainer icon="fa-angle-left">
            <span style={{ position: 'relative', top: 2, }}>返回</span>
          </NavItemContainer>
        </NavLink>
        <SectionTitle>
          <DateBadge>{year}-{month}</DateBadge>
          月報
          <br />
          <span style={{ fontSize: 12, }}>
            機構: {USERS_MAP[projectId].companyName}
          </span>
        </SectionTitle>
        <NavLink
          to={`/${projectId}/${year}/${month}/performance`}
          style={styles.navLink}
          activeStyle={{ backgroundColor: '#eee', }}
        >
          <NavItemContainer icon="fa-pie-chart">
            投資組合現況與績效
          </NavItemContainer>
        </NavLink>
        <NavLink
          to={`/${projectId}/${year}/${month}/prediction`}
          style={styles.navLink}
          activeStyle={{ backgroundColor: '#eee', }}
        >
          <NavItemContainer icon="fa-globe">
            本月市場預測結果
          </NavItemContainer>
        </NavLink>
        {
          hasAdjustment
            ? <NavLink
              to={`/${projectId}/${year}/${month}/adjustment`}
              style={styles.navLink}
              activeStyle={{ backgroundColor: '#eee', }}
            >
              <NavItemContainer icon="fa-wrench">
                本月投資組合調整
              </NavItemContainer>
            </NavLink>
            : <NavItemContainer
              title="本月份投組無rebalance"
              icon="fa-wrench"
              style={{ opacity: 0.3, cursor: 'not-allowed', }}
            >
              本月投資組合調整
            </NavItemContainer>
        }
        {
          window.location.hash === '#jis' &&
          // true &&
          <NavLink
            to={`/${projectId}/${year}/${month}/symbol-summary`}
            style={styles.navLink}
            activeStyle={{ backgroundColor: '#eee', }}
          >
            <NavItemContainer icon="fa-line-chart">
              個別標的總覽
            </NavItemContainer>
          </NavLink>
        }
        <NavItemContainer
          icon="fa-sign-out"
          onClick={unAuthUser}
          style={{ borderTop: 'solid 1px #ccc', marginTop: 40, }}
        >
          登出
        </NavItemContainer>
      </SideNavContainer>
    );
  }
}

SideNav.propTypes = PropTypes;
SideNav.defaultProps = DefaultProps;

function mapStateToProps(state) {
  return {
    ...state,
    token: state.appState.userToken,
    company: state.appState.company,
  };
}

const dispatchObj = {
  unAuthUser,
  resetErrMsg,
  fetchAdjustment,
};

export default connect(mapStateToProps, dispatchObj)(withRouter(SideNav));



// WEBPACK FOOTER //
// ./src/components/global/SideNav/SideNav.js